import React from "react";
import "./Navbar.css";
import { FaTruck } from "react-icons/fa";
import { Link } from "react-router-dom";
import PATHS from "../../routes/Paths";

const TopNavbar = () => {
  return (
    <div className="topNavbar">
      <p className="wlcmText">
        Welcome to <span className="brandName">Easy QIST</span>
      </p>

      <div className="marquee">
        <div className="marquee-content">
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
        </div>
      </div>

      <Link to={PATHS.orderHistory} className="nav-link" data-toggle="tab">
        <FaTruck style={{ color: '#2ECC40', marginRight: 6 }} aria-label="Track Order" />
        Track order and history
      </Link>
    </div>
  );
};

export default TopNavbar;
